import React, { Component } from "react";
import SideBarsJsx from "./sidebar.jsx"
import axios from 'axios'
import {
  baseURL
} from "../../../../constants/applicationConstants.js";
import { Loader } from '../../../common/loader/loader.jsx';

export class SideBarsJsxclass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseData: null,
      isLoading: false
    };
  }

  componentDidMount = () => {
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let expertID = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))

    if (token && expertID) {
      this.callDetails()
    }
  }

  callDetails = () => {
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let expertID = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    
    // Create cache key for this specific expert - include expertID
    const cacheKey = `expertDetails_${expertID}`;
    
    // Check if data exists in localStorage
    const cachedData = localStorage.getItem(cacheKey);
    
    if (cachedData) {
      // Use cached data
      try {
        const parsedData = JSON.parse(cachedData);
        
        // Set the cached data to state
        this.setState({ 
          responseData: parsedData,
          isLoading: false 
        });
        
        // Also set the required localStorage items from cached data
        if (parsedData?.firstName) {
          localStorage.setItem("legalName", parsedData.firstName);
        }
        if (parsedData?.planName) {
          localStorage.setItem("planName", parsedData.planName);
        }
        if (parsedData?.slugUrl) {
          localStorage.setItem("slugURL", parsedData.slugUrl);
        }
        
        // Data is available from cache, no need to make API call
        return;
      } catch (error) {
        console.error('Error parsing cached data:', error);
        // If parsing fails, remove corrupted cache and make API call
        localStorage.removeItem(cacheKey);
      }
    }
    
    // Make API call only if no cached data exists
    this.setState({ isLoading: true });
    
    axios.get(`${baseURL}/expert/${expertID}/details`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      const responseData = res.data?.data;
      
      // Store the response data in localStorage
      if (responseData) {
        localStorage.setItem(cacheKey, JSON.stringify(responseData));
        
        // Set additional localStorage items
        if (responseData.firstName) {
          localStorage.setItem("legalName", responseData.firstName);
        }
        if (responseData.planName) {
          localStorage.setItem("planName", responseData.planName);
        }
        if (responseData.slugUrl) {
          localStorage.setItem("slugURL", responseData.slugUrl);
        }
      }
      
      // Set state with the response data
      this.setState({ 
        responseData: responseData,
        isLoading: false 
      });

    }).catch(err => {
      console.error('API call failed:', err);
      // Remove invalid cache on error
      localStorage.removeItem(cacheKey);
      this.setState({ 
        isLoading: false,
        responseData: null 
      });
    })
  }

  render() {
    return (
      <div>
        <SideBarsJsx
          response={this.state.responseData}
        />
        {this.state.isLoading && <Loader />}
      </div>
    );
  }
}

export default SideBarsJsxclass;